// .background の高さを、カルーセルのY軸中央が下端に来るよう調整
import imagesLoaded from 'imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.carousel');
  const bg = document.querySelector('.background');
  if (!carousel || !bg) return;

  const adjustBgHeight = () => {
    const carouselTop = carousel.getBoundingClientRect().top + window.pageYOffset;
    const bgTop = bg.getBoundingClientRect().top + window.pageYOffset;
    bg.style.height = (carouselTop + carousel.offsetHeight / 2 - bgTop) + 'px';
  };

  let resizeTimer = null;
  imagesLoaded(carousel, adjustBgHeight);
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustBgHeight, 500);
  });
});
